module.exports = __webpack_public_path__ + "static/img/changJingImg3.05f6f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/changJingImg3.png
// module id = 3WXG
// module chunks = 2